﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

//No internet
require('typeahead-addresspicker');

import tpl_login from './tpl/login.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';

import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import config from '../../../common/config';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';

export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_login({ model: this.model.toJSON() });
    },
    initialize: function () {
        var self = this;
        this.app = this.options.app;

        this.model.attributes.Email = '';
        this.model.attributes.Password = '';
    },
    regions: {
    },
    onBeforeShow: function () {
    },
    ui: {
        'login_inputEmail' : '#login_inputEmail',
        'login_inputPassword' : '#login_inputPassword',
        'login_btnSubmit' : '#login_btnSubmit',
    },
    events: {
        'click @ui.login_btnSubmit': 'login_btnSubmitClick'
    },
    onRender: function () {
    },
    onAttach(){
    },
    login_btnSubmitClick: function (event) {
        this.model.set({
            Email : this.ui.login_inputEmail.val(),
            Password: this.ui.login_inputPassword.val()
        });
        this.model.save(this.model.attributes, {
            success: function () {
                alert("Succes");
            },
            error: function () {
                alert("Error");
            },
        });
    },
    
}, Backbone.Radio.Requests);
